export enum ValidationErrorCode {
  UNKNOWN = -1,
  MISSING_FIELD = 100,
  INVALID_EMAIL = 200,
  FIELD_EMPTY = 300,
  INVALID_DATE = 400,
  INVALID_VALUE = 500,
  BULK_UPLOAD_UNKNOWN_FIELD = 600,
}
